import BuildingLimitsCommercialWithGuid from './BuildingLimitsCommercialWithGuid';

export default class BuildingLimitsCommercialWithGuidAndRcv extends BuildingLimitsCommercialWithGuid {
	public buildingReplacementCostValue: number | null = null;

	public constructor() {
		super();
	}
};